import React, { useContext } from 'react'
import { DesignAssetContext } from '../../pages/CustomHooks/ContextApi';

const EccHyd = () => {
    const {
        
        rectangleWidth
      } = useContext(DesignAssetContext);
  return (
    <svg>
        {" "}
        <g id="ECC">
          {" "}
          <svg x="10" y="0">
            {" "}
            <g
              id="ECC"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g id="ECC" transform="translate(-532.000000, -514.000000)">
                
                <g
                  id="SLD/Infos/Microgrid_Background"
                  transform="translate(532.000000, 514.000000)"
                >
                  <rect
                    id="Rectangle-Copy-24"
                    stroke="var(--se-sld-circline)"
                    strokeWidth="3"
                    x="310"
                    y={"269"}
                    width={ rectangleWidth }
                    height= "230"
                    rx="16"
                  />
                  <text
                    id="AAA"
                    fontFamily="Nunito-Regular, Nunito"
                    fontSize="18"
                    fontWeight="normal"
                    fill="var(--se-sld-circline)"
                  >
                    <tspan x="630" y="460">
                      Low Voltage{" "}
                    </tspan>
                    /{" "}
                    <tspan x="750" y="460">
                      Switchboard
                    </tspan>{" "}
                  </text>{" "}
                </g>{" "}
              </g>{" "}
            </g>{" "}
          </svg>{" "}
        </g>{" "}
        </svg>
  )
}

export default EccHyd